import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import registerServiceWorker from './registerServiceWorker';
import history from './history';
import { Router } from 'react-router-dom';
import App from './App';
import store from './store';

const render = () =>
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>,
    document.getElementById('root')
  );

render();

// if (module.hot) {
// 	module.hot.accept();
// }

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js